import API from '../components/API';
import Moment from 'moment';
import Practices from '../models/Practices';
import {calc_distance} from '../components/helpers';

export const initDispPlayer = (user) => {

  return (dispatch, getState) => {

    const token = getState().auth.token;

    let onSuccess = function (res) {
      if (res.status === 200) {
        res.data.forEach((m) => {
          if (m.id == user.id) {
            return dispatch({ type: 'SET_TARGET_USER', user: m });
          }
        });

      } else {
        dispatch({ type: "GET_PLAYERS_ERROR", data: res.data });
        throw res.data;
      }
    }

    let onError = function (res) {
      if (res.status >= 500) {
        console.log("Server Error!");
        throw res;
      } else if (res.status >= 400 && res.status < 500) {
        dispatch({ type: "AUTHENTICATION_ERROR", data: res.data });
        throw res.data;
      } else {
        dispatch({ type: "AUTHENTICATION_ERROR", data: res.data });
        throw res.data;
      }
    }

    API.getMembers({ token: token, onSuccess: onSuccess, onError: onError });
  }
}


export const getPlayers = () => {

  return (dispatch, getState) => {

    const token = getState().auth.token;

    let onSuccess = function (res) {
      if (res.status === 200) {

        return dispatch({ type: 'GET_PLAYERS', players: res.data });

      } else {
        dispatch({ type: "GET_PLAYERS_ERROR", data: res.data });
        throw res.data;
      }
    }

    let onError = function (res) {
      if (res.status >= 500) {
        console.log("Server Error!");
        throw res;
      } else if (res.status >= 400 && res.status < 500) {
        dispatch({ type: "AUTHENTICATION_ERROR", data: res.data });
        throw res.data;
      } else {
        dispatch({ type: "AUTHENTICATION_ERROR", data: res.data });
        throw res.data;
      }
    }

    API.getMembers({ token: token, onSuccess: onSuccess, onError: onError });
  }
}


//ユーザセレクタで、ユーザを選択した場合
export const handleSelectPlayer = (user) => {

  return (dispatch, getState) => {

    const token = getState().auth.token;

    //比較メンバーをリセット
    dispatch({ type: 'SET_MEMBERS_PRACTICES', practices: undefined, members: undefined });
    dispatch({ type: 'SET_TARGET_USER', user: user, target: undefined });

    let onSuccess = function (res) {
      if (res.status === 200) {

        //Practicesモデルのインスタンスを生成
        let practices = Practices.fromJSON(res.data);

        //初期に表示するPracticeを選別
        let latestPractice = practices.filterByDay(practices.getLatestDay());
        dispatch({ type: 'GET_PRACTICES', practices: practices, practicesOfDay: latestPractice, target: null })
        dispatch({ type: 'SET_PRACTICES_OF_DAY', practicesOfDay: null });

      } else {
        dispatch({ type: "AUTHENTICATION_ERROR", data: res.data });
        throw res.data;
      }
    }

    let onError = function (res) {
      if (res.status >= 500) {
        console.log("Server Error!");
        throw res;
      } else if (res.status >= 400 && res.status < 500) {
        dispatch({ type: "AUTHENTICATION_ERROR", data: res.data });
        throw res.data;
      } else {
        dispatch({ type: "AUTHENTICATION_ERROR", data: res.data });
        throw res.data;
      }
    }

    API.getPractices({ token: token, onSuccess: onSuccess, onError: onError, targetUser: user });
  }
}


export const getDevices = () => {

  return (dispatch, getState) => {

    const token = getState().auth.token;

    let onSuccess = function (res) {
      if (res.status === 200) {

        //ユーザが割り当たっていない場合
        let nouser = {
          last_name: "no user",
          first_name: "no user",
        };

        for (let i in res.data) {
          if (!res.data[i].user) {
            res.data[i].user = nouser;
          }
        }

        //通常のデバイス一覧 PlayserSelector
        return dispatch({ type: 'GET_DEVICES', devices: res.data });

      } else {
        dispatch({ type: "GET_DEVICES_ERROR", data: res.data });
        throw res.data;
      }
    }

    let onError = function (res) {
      if (res.status >= 500) {
        console.log("Server Error!");
        throw res;
      } else if (res.status >= 400 && res.status < 500) {
        dispatch({ type: "AUTHENTICATION_ERROR", data: res.data });
        throw res.data;
      } else {
        dispatch({ type: "AUTHENTICATION_ERROR", data: res.data });
        throw res.data;
      }
    }

    API.getDevices({ token: token, onSuccess: onSuccess, onError: onError });
  }
}


//関心区間の統計を再計算
export const reCalculationSummary = ({ target, from_idx, to_idx }) => {
  return (dispatch, getState) => {

		//統計値の再計算
		let count = 0;
    var max_spd = 0.0;
    var ave_spd = 0.0;
    var max_2s_spd = 0.0;
    var max_10s_spd = 0.0;
    var max_up_vmg = 0.0;
    var max_down_vmg = 0.0;
    var ave_up_vmg = 0.0;
    var ave_down_vmg = 0.0;

    var ave_pitch = 0.0;
    var ave_roll = 0.0;

    var count_up_vmg = 0;
    var count_down_vmg = 0;
    var count_2s = 0;
    var count_10s = 0;


    let m2s = [];
    let m10s = [];
    let gpses = [];
		for(let i=from_idx; i <= to_idx; i++, count++){
			let gps = target.gpses[i];
			gpses.push(gps);
      if (target.unit == "knot") {
        gps._speed = Math.round((gps._speed / 1.852) * 10) / 10
        gps._vmg = Math.round((gps._vmg / 1.852) * 10) / 10
      }
      if (target.wind_unit == "knot") {
        gps._wind_speed = Math.round((gps._wind_speed / 1.943) * 10) / 10
      }
      //統計算出
      ave_spd = ave_spd + gps._speed;//平均速度
      ave_pitch = ave_pitch + gps.pitch;//平均ピッチ
      ave_roll =  ave_roll  + gps.roll;//平均ロール
      if (max_spd < gps._speed)//最高速度
        max_spd = gps._speed;
      if (max_up_vmg < gps._vmg)
        max_up_vmg = gps._vmg;//最高アップVMG
      if (max_down_vmg > gps._vmg)
        max_down_vmg = gps._vmg;//最高ダウンVMG

      if (gps._vmg > 0.0) {
        ave_up_vmg = ave_up_vmg + gps._vmg;//平均アップVMG
        count_up_vmg = count_up_vmg + 1;
      } else {
        ave_down_vmg = ave_down_vmg + gps._vmg;//平均ダウンVMG
        count_down_vmg = count_down_vmg + 1;
      }
      //max2s max10s
      if (m2s.length < 2)
        m2s.push(gps._speed);
      else {
        let tmp_2s = 0.0;
        m2s.forEach((g) => {
          tmp_2s = tmp_2s + g;
        });
        tmp_2s = tmp_2s / 2;
        if (max_2s_spd < tmp_2s)
          max_2s_spd = tmp_2s       //2秒平均最高速度
        m2s.shift();//古いものを捨てる
        m2s.push(gps._speed);//refleth
      }
      if (m10s.length < 10)
        m10s.push(gps._speed);
      else {
        let tmp_10s = 0.0;
        m10s.forEach((g) => {
          tmp_10s = tmp_10s + g;
        });
        tmp_10s = tmp_10s / 10;
        if (max_10s_spd < tmp_10s)
          max_10s_spd = tmp_10s    //10秒平均最高速度
        m10s.shift();//古いものを捨てる
        m10s.push(gps._speed);//refleth
      }
		}//gps loop

		//表示値の最新化
		target.set_max_speed(max_spd);
		target.set_max_vmg_up(max_up_vmg);
		target.set_max_vmg_down(max_down_vmg);
		target.set_ave_speed(Math.round(ave_spd / count * 10) / 10);
		target.set_max_2s_spd(Math.round(max_2s_spd * 10) / 10);
		target.set_max_10s_spd(Math.round(max_10s_spd * 10) / 10);
		target.set_ave_vmg_up(Math.round(ave_up_vmg / count_up_vmg * 10) / 10);
		target.set_ave_vmg_down(Math.round(ave_down_vmg / count_down_vmg * 10) / 10);
		target.set_ave_pitch(Math.round(ave_pitch / count * 10) / 10);
		target.set_ave_roll(Math.round(ave_roll / count * 10) / 10);
		target.set_st(target.gpses[from_idx].time);
		target.set_et(target.gpses[to_idx].time);
		//表示値の最新化(Rowing)
    //距離の算出
    //Rowing
    const duration = Moment.duration(
      target.gpses[to_idx].time.diff(target.gpses[from_idx].time)
    );
    const seconds = duration.asSeconds();
    target.set_duration_seconds(seconds);
    var distance = calc_total_distance(gpses);
    target.set_distance(distance)
    target.set_pace100m_seconds(Math.round(seconds/(distance/100)))
    target.set_pace500m_seconds(Math.round(seconds/(distance/500)))
    target.set_pace1000m_seconds(Math.round(seconds/(distance/1000)))

    //選択区間のストローク数(GPS速度のみから算出。api_server側のcalc_stroke_gps_onlyと同じロジック)
    var stroke = calc_stroke_gps_only(gpses, target.unit);
    var ave_storke_per_minutes = seconds > 0 ? Math.round(stroke / (seconds / 60)) : 0;
    var stroke100m  = distance > 0 ? Math.round(stroke / (distance / 100))  : 0;
    var stroke500m  = distance > 0 ? Math.round(stroke / (distance / 500))  : 0;
    var stroke1000m = distance > 0 ? Math.round(stroke / (distance / 1000)) : 0;

    target.set_stroke(stroke);
    target.set_ave_storke_per_minutes(ave_storke_per_minutes);
    target.set_stroke100m(stroke100m);
    target.set_stroke500m(stroke500m);
    target.set_stroke1000m(stroke1000m);

    dispatch({ type: 'RE_CALC_SUMMARY', target: target });
  }
}

/**
 * GPS配列から総距離（m）を算出
 */
export function calc_total_distance(gpses) {
  if (!Array.isArray(gpses) || gpses.length < 2) return 0;

  let total = 0;

  for (let i = 1; i < gpses.length; i++) {
    const prev = gpses[i - 1];
    const curr = gpses[i];

    // 無効座標排除
    if (!prev.lat || !prev.lon || !curr.lat || !curr.lon) continue;

    total += calc_distance(prev.lat, prev.lon, curr.lat, curr.lon);
  }

  return total;
}

//------------------------------------------------------------------
// GPS単独でのストローク数算出（api_server の calc_stroke.calc_stroke_gps_only と同じロジック）
// モーションセンサーを使わず、5Hz程度のGPS速度のみからストローク数を推定する。
//------------------------------------------------------------------

const GPS_STROKE_SEG_DIST_M = 30.0;     // 移動平均速度を計算する距離窓
const GPS_STROKE_SPEED_THR_KMH = 4.0;   // この距離窓での平均速度がこれ以上なら走行中とみなす
const GPS_STROKE_MIN_SEG_POINTS = 10;   // 短すぎる区間は無視する（5Hzなら2秒相当）
const GPS_STROKE_MIN_PERIOD_S = 1.2;    // ストローク周期の探索レンジ(12〜50spm相当)
const GPS_STROKE_MAX_PERIOD_S = 5.0;
const GPS_STROKE_SAMPLE_HZ = 5.0;
// 各ピーク時刻xの前後2秒間(計4秒間)の平均速度がこれ未満なら、
// 低速走行中の誤検知としてそのピークをストロークに数えない
const GPS_STROKE_PEAK_WINDOW_S = 2.0;

// gps._speed は reCalculationSummary 内でユーザーの表示単位(knot)に
// 変換済みの場合があるため、km/hに正規化して返す
function speedKmh(gps, unit) {
  return unit === 'knot' ? gps._speed * 1.852 : gps._speed;
}

// 連続するGPS点を、「直近 segDistM 移動する間の平均速度が speedThrKmh 以上」
// となる区間ごとにグルーピングする
function activeGpsSegments(gpses, unit, segDistM, speedThrKmh, minPoints) {
  const n = gpses.length;
  if (n === 0) return [];

  const cumDist = new Array(n).fill(0);
  for (let i = 1; i < n; i++) {
    const prev = gpses[i - 1];
    const curr = gpses[i];
    if (!prev.lat || !prev.lon || !curr.lat || !curr.lon) {
      cumDist[i] = cumDist[i - 1];
      continue;
    }
    cumDist[i] = cumDist[i - 1] + calc_distance(prev.lat, prev.lon, curr.lat, curr.lon);
  }

  // ウィンドウ[i, j]の平均速度を、都度スキャンし直すのではなく差分更新する(O(n)化)。
  // 停止中(距離がほぼ増えない)区間が長いと、segDistM分の移動に多数の点を
  // 要するため、毎回スキャンし直す実装だと最悪O(n^2)になり非常に遅くなる。
  const active = new Array(n).fill(false);
  let j = -1;
  let windowSum = 0;
  let windowCount = 0;
  for (let i = 0; i < n; i++) {
    if (j < i - 1) j = i - 1;
    while (j + 1 < n && (cumDist[j + 1] - cumDist[i]) <= segDistM) {
      j += 1;
      windowSum += speedKmh(gpses[j], unit);
      windowCount += 1;
    }
    const avgSpeed = windowCount > 0 ? windowSum / windowCount : 0;
    active[i] = avgSpeed >= speedThrKmh;
    windowSum -= speedKmh(gpses[i], unit);
    windowCount -= 1;
  }

  const segments = [];
  let start = null;
  for (let i = 0; i < n; i++) {
    if (active[i] && start === null) {
      start = i;
    } else if (!active[i] && start !== null) {
      segments.push(gpses.slice(start, i));
      start = null;
    }
  }
  if (start !== null) segments.push(gpses.slice(start));

  return segments.filter((seg) => seg.length >= minPoints);
}

// numpy.convolve(x, ones(win)/win, mode='same') 相当の中心移動平均（端はゼロ埋め扱い）
function centeredMovingAverage(arr, win) {
  const n = arr.length;
  const offset = Math.floor((win - 1) / 2);
  const result = new Array(n).fill(0);
  for (let i = 0; i < n; i++) {
    let sum = 0;
    for (let k = 0; k < win; k++) {
      const idx = i + k - offset;
      if (idx >= 0 && idx < n) sum += arr[idx];
    }
    result[i] = sum / win;
  }
  return result;
}

// 線形補間 (np.interp相当)
function linterp(x, xs, ys) {
  const n = xs.length;
  if (x <= xs[0]) return ys[0];
  if (x >= xs[n - 1]) return ys[n - 1];
  let lo = 0, hi = n - 1;
  while (hi - lo > 1) {
    const mid = (lo + hi) >> 1;
    if (xs[mid] <= x) lo = mid; else hi = mid;
  }
  const t = (x - xs[lo]) / (xs[hi] - xs[lo]);
  return ys[lo] + t * (ys[hi] - ys[lo]);
}

function autocorrAtLag(dd, lag) {
  let sum = 0;
  for (let t = 0; t < dd.length - lag; t++) {
    sum += dd[t] * dd[t + lag];
  }
  return sum;
}

function prominenceAt(arr, p) {
  let lMin = arr[p];
  for (let j = p - 1; j >= 0; j--) {
    if (arr[j] > arr[p]) break;
    lMin = Math.min(lMin, arr[j]);
  }
  let rMin = arr[p];
  for (let k = p + 1; k < arr.length; k++) {
    if (arr[k] > arr[p]) break;
    rMin = Math.min(rMin, arr[k]);
  }
  return arr[p] - Math.max(lMin, rMin);
}

// 1区間（走行中と判定されたGPS点列）の速度トレースから、自己相関で支配的な
// ストローク周期を推定し、その周期に合わせたピーク検出でストローク数を数える
function countStrokesInSegment(gpsSegment, unit, fs) {
  const times = [];
  const speeds = [];
  gpsSegment.forEach((gps) => {
    if (!gps.time) return;
    times.push(gps.time.valueOf() / 1000.0);
    speeds.push(speedKmh(gps, unit) || 0);
  });
  if (times.length < 2) return 0;

  const t0 = times[0], t1 = times[times.length - 1];
  if (t1 - t0 < GPS_STROKE_MIN_PERIOD_S * 2) return 0;

  const uniformT = [];
  for (let t = t0; t < t1; t += 1.0 / fs) uniformT.push(t);
  const uniformS = uniformT.map((t) => linterp(t, times, speeds));

  const win = Math.max(3, Math.round(4.0 * fs));
  const trend = centeredMovingAverage(uniformS, win);
  const detrended = uniformS.map((v, i) => v - trend[i]);
  const n = detrended.length;
  if (n < 20) return 0;

  const mean = detrended.reduce((a, b) => a + b, 0) / n;
  const dd = detrended.map((v) => v - mean);

  const lagMin = Math.round(GPS_STROKE_MIN_PERIOD_S * fs);
  const lagMax = Math.min(Math.round(GPS_STROKE_MAX_PERIOD_S * fs), n - 1);
  if (lagMax <= lagMin) return 0;

  const ac0 = autocorrAtLag(dd, 0);
  if (ac0 === 0) return 0;

  let bestLag = lagMin, bestAc = -Infinity;
  for (let lag = lagMin; lag <= lagMax; lag++) {
    const ac = autocorrAtLag(dd, lag) / ac0;
    if (ac > bestAc) { bestAc = ac; bestLag = lag; }
  }
  if (bestLag <= 0) return 0;

  const minDist = Math.max(1, Math.round(0.7 * bestLag));
  const std = Math.sqrt(dd.reduce((a, b) => a + b * b, 0) / n);
  const promThr = std > 0 ? 0.3 * std : 0;

  const candidates = [];
  for (let i = 1; i < n - 1; i++) {
    if (detrended[i] >= detrended[i - 1] && detrended[i] > detrended[i + 1]) {
      candidates.push(i);
    }
  }
  let infos = candidates
    .map((p) => ({ index: p, prominence: prominenceAt(detrended, p) }))
    .filter((x) => x.prominence >= promThr);
  infos.sort((a, b) => b.prominence - a.prominence);

  const confirmed = [];
  infos.forEach((x) => {
    if (confirmed.every((c) => Math.abs(x.index - c) >= minDist)) {
      confirmed.push(x.index);
    }
  });

  // 各ピーク時刻xについて、前後2秒間(計4秒間)の平均速度が
  // GPS_STROKE_SPEED_THR_KMH 未満なら低速走行中の誤検知として除外する。
  // 前後2秒分のデータが無い(区間の始端・終端に近い)ピークも対象外とする。
  const windowSamples = Math.round(GPS_STROKE_PEAK_WINDOW_S * fs);
  let finalCount = 0;
  confirmed.forEach((idx) => {
    const lo = idx - windowSamples;
    const hi = idx + windowSamples;
    if (lo < 0 || hi >= n) return;
    let sum = 0;
    for (let k = lo; k <= hi; k++) sum += uniformS[k];
    const localAvgSpeed = sum / (hi - lo + 1);
    if (localAvgSpeed >= GPS_STROKE_SPEED_THR_KMH) finalCount++;
  });

  return finalCount;
}

/**
 * モーションセンサーを使わず、GPS速度（5Hz程度を想定）のみからストローク数を推定する。
 * api_server の calc_stroke.calc_stroke_gps_only と同じアルゴリズム。
 */
export function calc_stroke_gps_only(gpses, unit) {
  if (!Array.isArray(gpses) || gpses.length === 0) return 0;

  const segments = activeGpsSegments(
    gpses, unit, GPS_STROKE_SEG_DIST_M, GPS_STROKE_SPEED_THR_KMH, GPS_STROKE_MIN_SEG_POINTS
  );

  let total = 0;
  segments.forEach((seg) => {
    total += countStrokesInSegment(seg, unit, GPS_STROKE_SAMPLE_HZ);
  });

  return total;
}

